<template>
  <div style="position: relative;min-height: 100vh">
    <div class="windows-msg" v-if="type =='Windows'">
      <div id="qrcode" class="imgUrl"></div>
      <p class="error-msg">请使用手机浏览器打开窗口</p>
      <div>
        <p class="header">外链链接</p>
        <div class="bottoms">
          <p class="url copyText" style="text-align:left;">http://gathercloudsaas.com/to/{{ url }}</p>
          <div class="copybtn" @click="copyUrl">复制</div>
        </div>
      </div>
    </div>
    <div class="MicroMessenger-msg" v-else-if="type =='MicroMessenger'">
      <img src="@/assets/imags/error-msg.png" alt="" class="imgUrl">
    </div>
    <div class="success-msg" v-else-if="type === true">
      <!-- <div class="confirmheader">
        <img src="@/assets/imags/success.png" alt="" style="width:20px;vertical-align:middle;">
        <span style="font-size:17px;color:#000;margin-left:5px;vertical-align:middle;">请确认打开微信</span>
      </div>
      <div class="btn" @click="openUrl">打开微信</div>
      <div style="text-align:right;width:70%;margin:70px auto 0;" class="guidecontent">
        <div>注：如果点击上方“打开”没有跳转<br>请点击类似下方弹窗中的打开按钮</div>
        <img src="@/assets/imags/tail.png" style="width: 60px;margin-top:20px;">
      </div> -->
      <div class="success-msg-img-content">
        <img src="http://util.gathercloudsaas.com/images/ddb73456690e4aa496ed811ec1e4e356859951ca.jpeg" class="img" alt="">
        <img src="http://util.gathercloudsaas.com/images/31f06d5f0bd73877d4bc42a33249d18bf4138268.gif"  class="img">
        <img src="http://util.gathercloudsaas.com/images/6ab542a65429a9a8be3bf9f61bf66bb57145de2f.png" class="img" alt="">
      </div>
      <div>连接中...</div>
    </div>
    <div class="footer">
      由蓝小招SCRM提供技术支持，深圳汇客科技有限公司
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  data () {
    return {
      type: 'Windows', // 浏览器类型
      url: '',
    }
  },
  created () {
    const _this = this
    if (!this.$route.params.id) {
      window.location.href = '/home'
    }
    this.url = this.$route.params.id
    console.log(this.$route);
    this.getPageData()
    window.onload = function () { 
      //这里面写你要干的事，不就是拿到浏览器的信息。
      var  u = navigator.userAgent;  //拿到了浏览器信息，想要的都在里面
      if (u.indexOf('Windows') > -1) {
        _this.type = 'Windows'
        _this.$nextTick(() => {
          _this.init()
        })
      } else if (u.indexOf('MicroMessenger') > -1) {
        _this.type = 'MicroMessenger'
      } else if (u.indexOf('BytedanceWebview')) { 
        _this.type = true
        // _this.$http.put(`http://wx4e13872d56239f5e.wxopen.gathercloudsaas.com/api/h5/fansPlusView/${_this.url}`)
        _this.skipApp()
        // alert('字节跳动')
      } else {
        // alert('普通浏览器')
        _this.type = true
        // _this.$http.put(`http://wx4e13872d56239f5e.wxopen.gathercloudsaas.com/api/h5/fansPlusView/${_this.url}`)
        _this.skipApp()
      }
      _this.skipApp()

    }
  },
  mounted () {
  },
  methods: {
    getPageData (url) { // 获取页面数据
      this.$http.get(`http://wx4e13872d56239f5e.wxopen.gathercloudsaas.com/api2/gainFans/getSceneByUrl?url=http://gathercloudsaas.com/to/${this.url}`).then(({ data }) => {
        document.title = data.result.titleInfo.name
        let meta = document.getElementById('meta-content');
        meta.content = data.result.titleInfo.info;
        let link = document.getElementById('shortcut-icon');
        const url = 'http://util.gathercloudsaas.com' + data.result.titleInfo.logoUrl
        link.href = url
        let linkTwo = document.getElementById('apple-touch-icon');
        linkTwo.href = url
      })
    },

    skipApp () {
      this.$http.get(`http://wx4e13872d56239f5e.wxopen.gathercloudsaas.com/api2/gainFans/genUrlScheme?url=http://gathercloudsaas.com/to/${this.url}`).then(({ data }) => {
        window.location.href = data.result.openlink
        // window.location.href = 'weixin://dl/business/?t=' + this.url
      })
    },
    copyUrl () {
      var text = 'http://gathercloudsaas.com/to/' + this.url
      var input = document.createElement('input')
      // 整一个input
      // 赋值
      input.setAttribute('value', text);
      // 添加节点
      document.body.appendChild(input);
      // 选取文本域中的内容
      input.select();
      // 复制
      document.execCommand('Copy');
      // 删除掉没用的节点
      document.body.removeChild(input);
    },
    init () {
	    new QRCode(document.getElementById('qrcode'), {
	      text: 'http://gathercloudsaas.com/to/' + this.url, //要生成二维码的网址
	      width: 140,  // 图像宽度
	      height: 140, // 图像高度
	      colorDark: '#000000',  // 前景色
	      colorLight: '#ffffff', // 背景色
	      margin: 10, // 外边距
	      correctLevel: QRCode.CorrectLevel.L // 容错级别。属性值有：QRCode.CorrectLevel.L、QRCode.CorrectLevel.M、QRCode.CorrectLevel.Q、QRCode.CorrectLevel.H
	    })
	  },
    openUrl () {
      window.location.href = 'weixin://dl/business/?t=' + this.url
    }
  }
}
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
.windows-msg {
  width: 470px;
  margin: 0 auto;
  text-align: center;
  padding-top: 100px;
  .imgUrl {
    display: flex;
    justify-content: center;
    img {
      width: 160px;
      height: 160px;
    }
  }
  .error-msg {
    font-size: 18px;
    color: #000;
    margin-top: 30px;
    text-align: center;
  }
  .header {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    margin-top: 40px;
    width: 100%;
    text-align: left;
  }
  .bottoms {
    width: 470px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .copyText {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      margin: 0;
    }
    .copybtn {
      width: 65px;
      height: 32px;
      cursor: pointer;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #7F8FEF;
      font-size: 14px;
      font-weight: 400;
      color: #7F8FEF;
      text-align: center;
      line-height: 32px;
    }
  }
}
.MicroMessenger-msg {
  .imgUrl {
    width: 100%;
  }
}
.success-msg {
  position: fixed;
  top: 15%;
  text-align: center;
  width: 100%;
  left: 0;
  right: 0;
  font-size: 68px;
  .success-msg-img-content {
    display: flex;
    justify-content: center;
    margin-bottom: 60px;
    .img {
      width: 220px;
      height: 220px;
    }
  }
  .btn {
    width: 80%;
    height: 120px;
    line-height: 60px;
    border-radius: 5px;
    text-align: center;
    background-color: #1AAD19;
    color: #fff;
    font-size: 32px;
    margin: 60px auto 0;
  }
  .guidecontent div {
    color: #1AAD19;
    font-size: 28px;
    text-align: center;
  }
}
.footer {
  position: fixed;
  bottom: 20px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  width: 100%;
  left: 0;
  right: 0;
  color: #999;
}
</style>
